import { render, staticRenderFns } from "./OrganizationInvite.vue?vue&type=template&id=43b8c68a&"
import script from "./OrganizationInvite.vue?vue&type=script&lang=js&"
export * from "./OrganizationInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports